import React from 'react'
import DateTime from 'react-datetime'
import Icon from './Icon'
import moment from 'moment'

const format = "HH:mm"
const TimeField = ({value, onChange}) => 
  <div className="input-group">
      <DateTime inputProps={{className:'form-control'}}
                value={moment(value, format)}
                viewMode={"time"}
                timeFormat={format}
                dateFormat={false} 
                onChange={(m) => onChange(moment(m).format(format))}
                />
      <span className="input-group-addon">
        <Icon name="clock-o"/>
      </span>
  </div>

TimeField.propTypes = {
  value: React.PropTypes.oneOfType([
    React.PropTypes.string, 
    React.PropTypes.instanceOf(Date)
  ]).isRequired,
  onChange: React.PropTypes.func.isRequired,
}
export default TimeField



/** WEBPACK FOOTER **
 ** ./app/components/TimeField.jsx
 **/